const critterIcons = {
    bug: require('./Bug_Icon.png'),
    fish: require('./Fish_Icon.png'),
    sea: require('./Sea_Creature_Icon.png')
}

export default critterIcons;